import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';



import { CertificateRepository }
from '../../repositories/certificate.repository';
import { DocumentSystemGenerateModel } from '../../models/certificate/document-system-generate.model';

export class GetDocumentsSystemGeneratesUseCase implements UseCase< void, DocumentSystemGenerateModel> {

    constructor(
        private repository:
        CertificateRepository
    ) {}

    execute(): Observable<DocumentSystemGenerateModel> {

        return this.repository.getDocumentsSystemGenerates();
    }
}